import { useEffect, useState } from "react";
import InformationErrorModal from "../../../Components/Modals/InformationErrorModal"
import { DateBox } from "devextreme-react";
import { useParams } from "../../../../Providers/ParamsProvider";
import useDownloadFinanceDocuments from "../../../../Hooks/useDownloadFinanceDocuments";
import LoadingSpinner from "../../../Components/LoadingSpinner";
import YesNoCancelMessageModal from "../../../Components/Modals/YesNoCancelMessageModal";

const UnPaidInvoicesFilter = ({ dateFrom, dateTo, setDateTo, setDateFrom, dateFromRef, dateToRef, setSelectedDocType, selectedSeller, setSelectedSeller, setSelectedOrder, invoices, selectedDocType, selectedOrder }) => {
    const { isMobile } = useParams()
    const { handleGetBalancePdf, isLoadingBalancePdf } = useDownloadFinanceDocuments()

    const [showError, setShowError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [initialSellers, setInitialSellers] = useState(invoices.map(invoice => invoice.seller))
    const [showSelectWhModal, setShowSelectWhModal] = useState(false)

    const DateToOnValueChanged = (e) => {
        if (e.value) {
            const selectedDate = e.value.toLocaleString('en-CA').substring(0, 10)

            if (dateFrom.length === 0) {
                setDateTo(selectedDate)
            } else if (selectedDate < dateFrom) {
                setErrorMessage('Data DO nie może być wcześniejsza niż data OD!')
                setShowError(true)
                if (dateToRef.current) {
                    dateToRef.current.instance.reset()
                }
                setDateTo('')
            } else {
                setDateTo(selectedDate)
            }
        }
    }

    const DateFromOnValueChanged = (e) => {
        if (e.value) {
            const selectedDate = e.value.toLocaleString('en-CA').substring(0, 10)

            if (dateTo.length === 0) {
                setDateFrom(selectedDate)
            } else if (selectedDate > dateTo) {
                setErrorMessage('Data OD nie może być poźniejsza niż data DO!')
                setShowError(true)
                if (dateFromRef.current) {
                    dateFromRef.current.instance.reset()
                }
                setDateFrom('')
            } else {
                setDateFrom(selectedDate)
            }
        }
    }

    const clearFilters = () => {
        setSelectedDocType('')
        setSelectedSeller('')
        setDateFrom('')
        setDateTo('')
        setSelectedOrder('timeToPayAsc')

        if (dateFromRef.current) {
            dateFromRef.current.instance.reset();
        }
        if (dateToRef.current) {
            dateToRef.current.instance.reset();
        }
    }

    const handleGetBalance = () => {
        if (!isLoadingBalancePdf) {
            if (initialSellers && initialSellers.length > 1) {
                setShowSelectWhModal(true)
                return
            }
            else {
                handleGetBalancePdf(null)
            }
        }
    }

    const selectWhModalAnswer = (anaswer) => {
        let whId = null
        setShowSelectWhModal(false)
        switch (anaswer) {
            case 'Yes':
                whId = '0101'
                break
            case 'No':
                whId = '0201'
                break
            case 'Cancel':
                whId = null
                break
        }
        handleGetBalancePdf(whId)
    }

    // Pobranie unikalnych wartości do wyboru w filtrach
    const sellers = invoices && invoices.length > 0 ? [...new Set(invoices.map(invoice => invoice.seller).filter(seller => seller))] : []

    return (
        <>
            <YesNoCancelMessageModal
                show={showSelectWhModal}
                onHide={selectWhModalAnswer}
                title={'Wybór oddziału'}
                message={"Z jakiego oddziału chcesz wydrukować saldo?"}
                yesText="TG Instalacje – Poznań"
                noText="TG Instalacje – Warszawa"
                cancelText="Oba oddziały"
                showCloseButton={false}
            />
            <div className="col-12">
                <InformationErrorModal show={showError} setShow={setShowError} title={'Błędna data'} message={errorMessage} isError={false} />
                <div className="d-flex">
                    <div>
                        {isMobile ?
                            <div className="row">
                                <div className='col-6 date-filter'>
                                    <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Od</label>
                                    <DateBox acceptCustomValue={false} adaptivityEnabled={true} onValueChanged={DateFromOnValueChanged} ref={dateFromRef} />
                                </div>
                                <div className="col-6 date-filter">
                                    <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Do</label>
                                    <DateBox acceptCustomValue={false} adaptivityEnabled={true} onValueChanged={DateToOnValueChanged} ref={dateToRef} />
                                </div>
                                <div className="filters col-12 d-grid">
                                    <div>
                                        <label style={{ fontSize: '14px' }} htmlFor="docType">Rodzaj dokumentu</label>
                                        <select
                                            style={{ fontSize: '14px' }}
                                            id="docType"
                                            value={selectedDocType}
                                            onChange={(e) => setSelectedDocType(e.target.value)}
                                        >
                                            <option value="">Wszystkie</option>
                                            <option value="Faktury">Faktury</option>
                                            <option value="Korekty">Korekty</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: '14px' }} htmlFor="seller">Sprzedający</label>
                                        <select
                                            style={{ fontSize: '14px' }}
                                            id="seller"
                                            value={selectedSeller}
                                            onChange={(e) => setSelectedSeller(e.target.value)}
                                        >
                                            <option value="">Wszyscy sprzedający</option>
                                            {sellers.map((seller, index) => (
                                                <option key={index} value={seller}>{seller}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: '14px' }} htmlFor="seller">Sortuj według</label>
                                        <select
                                            style={{ fontSize: '14px' }}
                                            id="order"
                                            value={selectedOrder}
                                            onChange={(e) => setSelectedOrder(e.target.value)}
                                        >
                                            <option value="timeToPayAsc">Termin rosnąco</option>
                                            <option value="timeToPayDesc">Termin malejąco</option>
                                            <option value="newest">Data dok. malejąco</option>
                                            <option value="oldest">Data dok. rosnąco</option>
                                            <option value="docDesc">Nr dok. malejąco</option>
                                            <option value="docAsc">Nr dok. rosnąco</option>
                                            <option value="valueDesc">Wartość malejąco</option>
                                            <option value="valueAsc">Wartość rosnąco</option>
                                            <option value="paidDesc">Wpłacono malejąco</option>
                                            <option value="paidAsc">Wpłacono rosnąco</option>
                                        </select>

                                    </div>
                                    <button
                                        style={{ fontSize: '15px', height: '40px' }}
                                        onClick={() => {
                                            clearFilters()
                                        }}
                                        className='btn-app-primary'>
                                        X
                                    </button>
                                </div>
                            </div> :
                            <div className="row">
                                <div className=' col-2 date-filter'>
                                    <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Od</label>
                                    <DateBox acceptCustomValue={false} adaptivityEnabled={true} onValueChanged={DateFromOnValueChanged} ref={dateFromRef} />
                                </div>
                                <div className="col-2 date-filter">
                                    <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Do</label>
                                    <DateBox acceptCustomValue={false} adaptivityEnabled={true} onValueChanged={DateToOnValueChanged} ref={dateToRef} />
                                </div>
                                <div className="filters col-7 ">
                                    <div>
                                        <label style={{ fontSize: '14px' }} htmlFor="docType">Rodzaj dokumentu</label>
                                        <select
                                            style={{ fontSize: '14px' }}
                                            id="docType"
                                            value={selectedDocType}
                                            onChange={(e) => setSelectedDocType(e.target.value)}
                                        >
                                            <option value="">Wszystkie</option>
                                            <option value="Faktury">Faktury</option>
                                            <option value="Korekty">Korekty</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: '14px' }} htmlFor="seller">Sprzedający</label>
                                        <select
                                            style={{ fontSize: '14px' }}
                                            id="seller"
                                            value={selectedSeller}
                                            onChange={(e) => setSelectedSeller(e.target.value)}
                                        >
                                            <option value="">Wszyscy sprzedający</option>
                                            {sellers.map((seller, index) => (
                                                <option key={index} value={seller}>{seller}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: '14px' }} htmlFor="seller">Sortuj według</label>
                                        <select
                                            style={{ fontSize: '14px' }}
                                            id="order"
                                            value={selectedOrder}
                                            onChange={(e) => setSelectedOrder(e.target.value)}
                                        >
                                            <option value="timeToPayAsc">Termin rosnąco</option>
                                            <option value="timeToPayDesc">Termin malejąco</option>
                                            <option value="newest">Data dok. malejąco</option>
                                            <option value="oldest">Data dok. rosnąco</option>
                                            <option value="docDesc">Nr dok. malejąco</option>
                                            <option value="docAsc">Nr dok. rosnąco</option>
                                            <option value="valueDesc">Wartość malejąco</option>
                                            <option value="valueAsc">Wartość rosnąco</option>
                                            <option value="paidDesc">Wpłacono malejąco</option>
                                            <option value="paidAsc">Wpłacono rosnąco</option>
                                        </select>
                                    </div>
                                    <button
                                        style={{ fontSize: '15px', width: '40px', height: '40px' }}
                                        onClick={() => {
                                            clearFilters()
                                        }}
                                        className='btn-app-primary mt-4'>
                                        X
                                    </button>
                                </div>
                            </div>}
                    </div>
                    {!isMobile && <div className="d-flex justify-content-start align-items-center">
                        {isLoadingBalancePdf ? (<LoadingSpinner width={1} height={1} bubble={false} loadingText="Pobieranie pliku ..." />)
                            :
                            (<button className="btn-app-secondary" onClick={handleGetBalance}>Wydrukuj saldo</button>)}
                    </div>}
                </div>
                {isMobile && <div>
                    {isLoadingBalancePdf ? (<LoadingSpinner width={1} height={1} bubble={false} loadingText="Pobieranie pliku ..." />)
                        :
                        (<button className="btn-app-secondary mb-3" onClick={handleGetBalance}>Wydrukuj saldo</button>)}
                </div>}
            </div>
        </>
    )
}

export default UnPaidInvoicesFilter